export default class Easing {
    static easeInOutCubic(a: number): number {
        return a < 0.5 ? 4 * a * a * a : 1 - Math.pow(-2 * a + 2, 3) / 2;
    }
}
